import ky from "ky";
import { gatherRequestReturn } from "./gatherRequestReturn";

function getCookie(name) {
	const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
	return match ? decodeURIComponent(match[1]) : "";
}

const httpClient = ky.create({
	prefix: import.meta.env.VITE_API_URL,
	timeout: 15_000,
	credentials: "include",
	hooks: {
		beforeRequest: [
			({ request }) => {
				const csrf = getCookie("csrf_token");
				if (csrf) {
					request.headers.set("X-CSRF-Token", csrf);
				}
			},
		],
	},
});

async function request(method, url, payload, options) {
	try {
		const hasBody = payload !== undefined;
		const kyOptions = hasBody ? { json: payload, ...options } : options;
		const response = await httpClient[method](url, kyOptions);
		const data = await response.json();

		return gatherRequestReturn({ isError: false, response: data, status: response.status });
	} catch (error) {
		const status = error.response?.status ?? 0;
		const body = error.data ?? { message: error.message ?? "Unknown error" };

		return gatherRequestReturn({ isError: true, response: body, status });
	}
}

const wrapper = {
	baseUrl: import.meta.env.VITE_API_URL,
	timeout: 15_000,

	get: (url, options) => request("get", url, undefined, options ?? {}),
	post: (url, payload, options) => request("post", url, payload, options ?? {}),
	put: (url, payload, options) => request("put", url, payload, options ?? {}),
	patch: (url, payload, options) => request("patch", url, payload, options ?? {}),
	delete: (url, options) => request("delete", url, undefined, options ?? {}),
};

export default wrapper;
